import Vue from 'vue'
import Vuex from 'vuex'
import Logger from "@/assets/Helper/Logger";

Vue.use(Vuex);

let Engraving = new Vuex.Store({
    state: {
        standard: {
            inside: {},
            outside: {},
            costs: {}
        },
        jewellery: {
            inside: {},
            outside: {},
            costs: {}
        },
        isNoFont: {
            inside: {
                3: true,
                4: true,
                31: true,
                58: true,
                60: true
            },
            outside: {
                19: true,
                61: true,
                91: true
            },
        }
    },
    actions: {
        setData(context, engravingData) {
            if (typeof engravingData === 'object' &&
                typeof engravingData.standard === 'object' &&
                typeof engravingData.standard.inside === 'object' &&
                typeof engravingData.standard.outside === 'object' &&
                typeof engravingData.standard.costs === 'object' &&
                typeof engravingData.jewellery.inside === 'object' &&
                typeof engravingData.jewellery.outside === 'object' &&
                typeof engravingData.jewellery.costs === 'object'
            ) {
                context.commit("setData", engravingData);
            } else {
                Logger.error('Invalid engravingData object');
            }
        }
    },
    mutations: {
        setData(state, engravingData) {
            state.standard.inside = JSON.parse(JSON.stringify(engravingData.standard.inside));
            state.standard.costs = JSON.parse(JSON.stringify(engravingData.standard.costs));
            state.standard.outside = JSON.parse(JSON.stringify(engravingData.standard.outside));

            state.jewellery.inside = JSON.parse(JSON.stringify(engravingData.jewellery.inside));
            state.jewellery.outside = JSON.parse(JSON.stringify(engravingData.jewellery.outside));
            state.jewellery.costs = JSON.parse(JSON.stringify(engravingData.jewellery.costs));
        }
    },
    getters: {
        getStandardList: state => (side) => {
            side = (side === 'outside') ? 'outside' : 'inside'
            return state.standard[side];
        },
        getJewelleryList: state => (side) => {
            side = (side === 'outside') ? 'outside' : 'inside'
            return state.jewellery[side];
        },
        getFontTextById: state => (fontId) => {
            let list = JSON.parse(JSON.stringify(state.standard.inside));
            list = Object.assign(list, state.standard.outside, state.jewellery.inside, state.jewellery.outside);

            if (fontId === 0) {
                return "";
            } else if (typeof list[fontId] === 'string') {
                return list[fontId];
            } else {
                Logger.error("Unknown font id: " + fontId);
            }
        },
        getCostsById: state => (jewelleryType, fontId) => {
            jewelleryType = (typeof jewelleryType === 'string' && jewelleryType === 'jewellery') ? 'jewellery': 'standard';
            if (typeof state[jewelleryType].costs[fontId] !== 'undefined') {
                return (parseFloat(state[jewelleryType].costs[fontId]));
            } else {
                return 0;
            }
        },
        getNoFonts: state => () => {
            return state.isNoFont;
        }
    }
});

export default Engraving;